import { isMobile, withOrientationChange } from 'react-device-detect';
import React from 'react';
import { presentationOptions } from '@/constants/states';

const PanelSizer = ({
  dimensions,
  component,
  configuration,
  isPortrait,
  onChange,
  width,
}) => {
  if (dimensions.width <= 0) {
    return (<div />);
  }

  const narrow = dimensions.width < width
      || (isMobile && isPortrait)
      || configuration.displayAs === presentationOptions.BASIC;
  const Component = narrow ? component.narrow : component.full;

  return (
    <Component
      configuration={configuration}
      code={configuration.code === undefined ? null : configuration.code}
      category={configuration.category}
      onChange={onChange}
      displayAs={configuration.displayAs}
      url={configuration.url}
    />
  );
};

export default withOrientationChange(PanelSizer);
